import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import globalConfig from '../config/config';
import BaseUrls from './baseUrls';
import { getAccessToken } from './token';

/** axios instance of backend service */
let axiosBackendInstance: AxiosInstance = axios.create();

/** axios instance of auth service */
let axiosAuthInstance: AxiosInstance = axios.create();

/**
 * to initialise the axios instances after the loading of configuration josn file
 */
const loadAxiosInstances = () => {
    const axiosBackendReqConfig: AxiosRequestConfig = {
        baseURL: BaseUrls.getProtocolBackendUrl(),
    };
    /** this is for local development when auth is disabled from config */
    if (!globalConfig.getConfig?.authEnabled) {
        if (axiosBackendReqConfig.headers === undefined) {
            axiosBackendReqConfig.headers = {};
        }
        if (!axiosBackendReqConfig.headers.authorization) {
            axiosBackendReqConfig.headers.authorization = `Bearer ${getAccessToken()}`;
        }
    }
    axiosBackendInstance = axios.create(axiosBackendReqConfig);
    axiosAuthInstance = axios.create({ baseURL: BaseUrls.getAuthBackendUrl() });
};

export { axiosBackendInstance, axiosAuthInstance, loadAxiosInstances };
